import { render } from "./ExtranetLogin.vue?vue&type=template&id=2e65e477&scoped=true"
import script from "./ExtranetLogin.vue?vue&type=script&lang=js"
export * from "./ExtranetLogin.vue?vue&type=script&lang=js"

import "./ExtranetLogin.vue?vue&type=style&index=0&id=2e65e477&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e65e477"]])

export default __exports__